import * as React from 'react';
import * as _ from 'underscore';
const compareObjects = require('fast-deep-equal');

import { IGlob } from '../../../../_common/application/ts/Glob';
import { ParameterField } from '../../../../_common/platform/tsx/ParameterField';
import { validators } from '../../../../_common/platform/ts/validators';
import * as Globalization from '../../../../_common/platform/ts/Globalization';

import StringField from '../../../../_common/platform/ts/StringField';
import NumberField from '../../../../_common/platform/ts/NumberField';
import { RadioGroupField } from '../../../../_common/platform/ts/RadioGroupField';
import { ExportFormats } from '../../../../_common/platform/ts/exportToExcel';

const Globalize = require('pdc-platform-Globalize');

export interface IExportToExcelParametersOptions {
    csvSeparator: string;
    limit: number;
    maxRecords: number;
    filename: string;
    widgetType: string;
    //unlimited: boolean;
}

export class ExportToExcelParameters extends React.Component<
    {
        setConfirmValueGetter(getConfirmValue);
        unsetConfirmValueGetter?();
        onSharedStateUpdate?(value: { isValid: boolean });

        options: IExportToExcelParametersOptions;
        glob: IGlob;
    },
    {
        value: {
            filename: string;
            format: ExportFormats;
            csvFieldSeparator: string;
            limit?: number;
            errors?: any[];
        };
        csvFieldSeparator;
        limit;
        filename;
        format;
    }
> {
    constructor(props) {
        super(props);

        const { options } = this.props;
        const defaultFormat: ExportFormats = 'csv';
        const fileName = options.filename + '.' + defaultFormat;

        let limitOptions = {};
        let labelText = '';

        if (options.maxRecords === 0) {
            labelText = 'Limit for number of Rows (Zero for unlimited)';
            limitOptions = {
                applyOnEnter: true,
                min: 0
            };
        } else {
            labelText = 'Limit for number of Rows (1-' + options.maxRecords + ')';
            limitOptions = {
                applyOnEnter: true,
                min: 1,
                max: options.maxRecords
            };
        }

        this.state = {
            csvFieldSeparator: new StringField(props.glob, 'CSV field separator', [], options.csvSeparator),

            limit: new NumberField(
                props.glob,
                labelText,
                [validators.number.not_negative],
                options.limit > options.maxRecords ? options.maxRecords : options.limit,
                limitOptions
            ),

            filename: new StringField(props.glob, 'Exported File Name', [validators.string.notEmpty], fileName),

            format: new RadioGroupField(props.glob, 'Export Format', [], defaultFormat, {
                layout: 'horizontal',
                name: 'RG_format',
                items: [
                    { text: 'CSV', value: 'csv' },
                    { text: 'XLSX', value: 'xlsx' }
                ]
            }),

            value: {
                csvFieldSeparator: options.csvSeparator,
                limit: options.limit > options.maxRecords ? options.maxRecords : options.limit, //options.unlimited ? 0 : options.limit,
                filename: fileName,
                format: defaultFormat,
                errors: []
            }
        };
    }

    getConfirmValue = () => {
        return this.state.value;
    };

    componentWillMount() {
        var obj = this.props.setConfirmValueGetter(this.getConfirmValue);
    }

    componentDidUpdate(prevProps, prevState) {
        if (!compareObjects(this.state.value.errors, prevState.value.errors)) {
            this.updateValidationFlag(this.state.value.errors);
        }
    }

    componentDidMount() {
        this.updateValidationFlag(this.state.value.errors);
    }

    updateValidationFlag = (errors) => {
        if (typeof this.props.onSharedStateUpdate === 'function') {
            this.props.onSharedStateUpdate({ isValid: errors.length === 0 });
        }
    };

    componentWillUnmount() {
        if (typeof this.props.unsetConfirmValueGetter === 'function') {
            this.props.unsetConfirmValueGetter();
        }
    }

    getChangeHandler = (name: string) => {
        return (value) => {
            const settings = _.clone(this.state.value);

            if (name === 'limit') {
                const result = this.state.limit.validate(value);

                if (!result.result) {
                    if (settings.errors.findIndex((e) => e.field === 'Limit') === -1) {
                        settings.errors.push({ field: 'Limit', error: result.errors });
                    }
                } else {
                    settings.errors = settings.errors.filter((e) => e.field !== 'Limit');
                }
            } else if (name === 'filename') {
                const result = this.state.filename.validate(value);

                if (!result.result) {
                    if (settings.errors.findIndex((e) => e.field === 'Filename') === -1) {
                        settings.errors.push({ field: 'Filename', error: result.errors });
                    }
                } else {
                    settings.errors = settings.errors.filter((e) => e.field !== 'Filename');
                }
            } else if (name === 'format') {
                if (value === 'csv') {
                    settings.filename = settings.filename.replace('.xlsx', '.csv');
                }
                if (value === 'xlsx') {
                    settings.filename = settings.filename.replace('.csv', '.xlsx');
                }
            }

            settings[name] = value;
            this.updateValidationFlag(settings.errors);
            this.setState({
                value: settings
            });

            var storageKey = 'print-settings';
            var storage = JSON.parse(this.props.glob.AppStore.getFromLocalStorage(storageKey)) || {};

            storage.excellimit = settings;
            if (storage) {
                this.props.glob.AppStore.saveToLocalStorage(storageKey, JSON.stringify(storage));
            }
        };
    };

    getCsvSeparator = () => {
        if (this.state.value.format === 'xlsx') {
            return null;
        }

        const EditComponent = this.state.csvFieldSeparator.constructor.EditComponent;

        return (
            <ParameterField
                param={this.state.csvFieldSeparator}
                label={'CSV Field Separator (type \\t if you want to use TAB as field separator)'}
                options={this.state.csvFieldSeparator.options}
            >
                <EditComponent
                    glob={this.props.glob}
                    value={this.state.value.csvFieldSeparator}
                    options={this.state.csvFieldSeparator.options}
                    onChange={this.getChangeHandler('csvFieldSeparator')}
                />
            </ParameterField>
        );
    };

    getFilename = () => {
        const EditComponent = this.state.filename.constructor.EditComponent;

        return (
            <ParameterField
                param={this.state.csvFieldSeparator}
                label={'Exported File Name'}
                options={this.state.filename.options}
            >
                <EditComponent
                    glob={this.props.glob}
                    value={this.state.value.filename}
                    options={this.state.filename.options}
                    onChange={this.getChangeHandler('filename')}
                />
            </ParameterField>
        );
    };

    getFormat = () => {
        const EditComponent = this.state.format.constructor.EditComponent;

        return (
            <ParameterField param={this.state.format} label={'Export Format'} options={this.state.format.options}>
                <EditComponent
                    glob={this.props.glob}
                    value={this.state.value.format}
                    options={this.state.format.options}
                    onChange={this.getChangeHandler('format')}
                />
            </ParameterField>
        );
    };

    getLimit = () => {
        // if (this.props.options.unlimited) {
        //     return null;
        // }
        const EditComponent = this.state.limit.constructor.EditComponent;

        const labelText =
            this.props.options.maxRecords === 0
                ? 'Limit for number of Rows (Zero for unlimited)'
                : 'Limit for number of Rows (1-' + this.props.options.maxRecords + ')';

        return (
            <ParameterField param={this.state.limit} label={labelText} options={this.state.limit.options}>
                <EditComponent
                    glob={this.props.glob}
                    value={this.state.value.limit}
                    options={this.state.limit.options}
                    onChange={this.getChangeHandler('limit')}
                />
            </ParameterField>
        );
    };

    render() {
        const { value } = this.state;
        const filename = this.getFilename();

        let errors: React.JSX.Element;
        let warninig: React.JSX.Element;
        let csvSeparator: React.JSX.Element;
        let limit: React.JSX.Element;
        let format: React.JSX.Element;

        if (value.errors.length > 0) {
            errors = (
                <ul className="text-danger">
                    {value.errors.map((e) => {
                        return <li>{e.field + ': ' + e.error}</li>;
                    })}
                </ul>
            );
        }

        switch (this.props.options.widgetType) {
            case 'pdc-widget-grid':
            case 'pdc-widget-data-edit':
                csvSeparator = this.getCsvSeparator();
                limit = this.getLimit();
                format = this.getFormat();
                break;
            case 'pdc-widget-half-pivot-grid':
                csvSeparator = this.getCsvSeparator();
                format = this.getFormat();
                break;
            case 'pdc-widget-pivot':
                break;
            default:
                csvSeparator = this.getCsvSeparator();
                limit = this.getLimit();
                break;
        }

        if (value.format === 'xlsx' && (value.limit === 0 || value.limit > 3000)) {
            warninig = <p className="text-info">{'The export to XLSX may be slow for large datasets'}</p>;
        }

        return (
            <div className="export-params">
                {errors}
                {format}
                {filename}
                {csvSeparator}
                {limit}
                {warninig}
                {limit != null && this.props.options.maxRecords !== 0 ? (
                    <p className="text-info">
                        <span>{'Ask Administrator if you need to export more record.'}</span>
                    </p>
                ) : null}
            </div>
        );
    }
}

export function getCSVSeparator() {
    if (localStorage['csvSeparator'] != null) {
        return localStorage['csvSeparator'];
    }

    const isIE = /(MSIE|Trident\/|Edge\/)/i.test(navigator.userAgent);

    if (isIE) {
        const l = ['aa', 'bb'];
        const s = l.toLocaleString();

        return s[2];
    }

    const locale = Globalization.getDefaultCulture();

    Globalization.applyCulture(locale);

    const s: string = Globalize.formatNumber(1.1);

    if (s[1] === ',') {
        return ';';
    } else {
        return ',';
    }
}
